import * as React from 'react';
import { Tooltip } from '@progress/kendo-react-tooltip';

type TooltipPosition = 'top' | 'bottom' | 'left' | 'right';

interface CustomTooltipProps {
    position?: TooltipPosition;
    children?: React.ReactNode;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
    position = 'top',
    children,
}) => {
    return (
        <Tooltip
            anchorElement="target"
            position={position}
        >
            {children}
        </Tooltip>
    );
};

export default CustomTooltip;